import React from "react";
import { CAPABILITY_CLASSES, STATUS_CLASSES } from "@/lib/agents";
import { cn } from "@/lib/utils";

export const CapabilityBadge = ({ capability, className = "", testId }) => (
  <span className={cn("inline-flex items-center rounded-md border px-1.5 py-0.5 font-mono text-[11px] font-medium tracking-wide", CAPABILITY_CLASSES[capability] || CAPABILITY_CLASSES.VISION, className)} data-testid={testId || `capability-badge-${capability}`}>
    {capability}
  </span>
);

export const StatusBadge = ({ status, label, className = "", testId }) => (
  <span className={cn("inline-flex items-center rounded-md border px-1.5 py-0.5 text-[11px] font-medium", STATUS_CLASSES[status] || STATUS_CLASSES.skipped, className)} data-testid={testId || `status-badge-${status}`}>
    {label || status}
  </span>
);

/** "model · latency" mono chip used in routing summaries */
export const ModelChip = ({ model, latencyMs, fallback, className = "", testId }) => (
  <span className={cn("inline-flex items-center gap-1 rounded-md border border-border bg-background px-1.5 py-0.5 font-mono text-[11px] text-foreground", className)} data-testid={testId || `model-chip-${model}`}>
    <span>{model}</span>
    {typeof latencyMs === "number" && <span className="text-muted-foreground">· {latencyMs} ms</span>}
    {fallback && <span className="text-amber-800">· fallback</span>}
  </span>
);
